import { Group } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useGetInteractionsQuery } from 'src/api/interactions';
import { Button } from 'src/components/Button';
import { Icon } from 'src/components/Icon';
import { PageLoader } from 'src/components/PageLoader';
import { PageTitle } from 'src/components/PageTitle';
import { InteractionsDataTable } from 'src/features/interaction/feature-interaction-list';
import { links } from 'src/router/routes';

import styles from './styles.module.css';

export const Interactions = () => {
  const { data: interactions, isPending } = useGetInteractionsQuery();
  const navigate = useNavigate();

  if (isPending) {
    return <PageLoader visible={true} />;
  }

  return (
    <div className={styles.container}>
      <PageTitle title="My Interactions" />

      <InteractionsDataTable
        interactions={interactions || []}
        isLoading={isPending}
      />
      <Group justify="flex-end" align="center" mt="xl">
        <Button
          variant="filled"
          size="md"
          round={true}
          icon={<Icon name="add" />}
          onClick={() => navigate(links.interactionNew)}
        >
          ADD NEW
        </Button>
      </Group>
    </div>
  );
};
